import React, { useContext } from 'react'

import { useTranslation } from 'react-i18next'

import { TitleContext } from '@providers/TitleProvider'
import { buildFormatString } from '@utils/format'

import AudioReference from './AudioReference'
import DetailElement from './DetailElement'
import DetailsSection from './DetailsSection'
import SellableArrangements from './SellableArrangements'

const Details: React.FC = () => {
  const { t } = useTranslation()
  const { title } = useContext(TitleContext)

  return (
    <DetailsSection>
      <h2 className="text-lg font-medium mb-5">{t('section.details')}</h2>
      <div className="flex flex-col pb-4 gap-3">
        <AudioReference />
        <DetailElement label="artist" value={title.metadata.artists.join(', ')} />
        <DetailElement label="composer" value={title.metadata.composers.join(', ')} />
        <DetailElement label="arranger" value={title.metadata.arrangers.join(', ')} />
        <DetailElement label="publisher" value={title.metadata.publisher} />
        <DetailElement
          label="genre"
          value={title.metadata.genres.map((genre) => t(`genre.${genre}`)).join(', ')}
        />
        <DetailElement
          label="difficulty"
          value={
            title.metadata.difficulty_level
              ? t(`difficultyLevel.${title.metadata.difficulty_level}`)
              : null
          }
        />
        <DetailElement label="format" value={buildFormatString(title.metadata)} />
        <SellableArrangements />
        <DetailElement label="description" value={title.metadata.description} />
      </div>
    </DetailsSection>
  )
}

export default Details
